import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Tooltip from 'react-toolbox/lib/tooltip'
import { IconButton } from 'react-toolbox/lib/button'

import styles from './styles.scss'

const TooltipButton = Tooltip(IconButton)

class ValidationTooltip extends Component {
  render() {
    return (
      <TooltipButton icon='warning' tooltip='Risk' theme={styles} />
    )
  }
}

export default CSSModules(ValidationTooltip, styles)
